import request from "@/utils/request";

export default function save(params) {
    return request({
        url: `/storeType/agency/save`,
        method: 'post',
        data:params
    })
}
